import * as React from 'react';
import { styled, css } from '../theme-provider';
import { useTableContext } from './table';
const StyledTableFoot = styled.tfoot.withConfig({ displayName: "StyledTableFoot", componentId: "sc-5e5vkr" }) `padding-top:${({ theme }) => theme.size.static200};padding-bottom:${({ theme }) => theme.size.static200};${({ fixedHeaderColumn, theme }) => fixedHeaderColumn &&
    css `
			& td:first-of-type {
				border-bottom: unset;
				position: sticky;
				background: ${theme.colors.background.primary};

				${theme.direction === 'rtl' ? 'right: 0;' : 'left: 0;'}

				mask: linear-gradient(black 0 0)
						${theme.direction === 'rtl' ? 'right' : 'left'},
					linear-gradient(
							${theme.direction === 'rtl' ? '270deg' : '90deg'},
							black,
							transparent
						)
						${theme.direction === 'rtl' ? 'left' : 'right'};
				mask-size:
					calc(100% - ${theme.size.static350}) 100%,
					${theme.size.static350} 100%;
				mask-repeat: no-repeat;
			}
		`}`;
export const TableFoot = ({ children }) => {
    const { fixedHeaderColumn } = useTableContext();
    return (React.createElement(StyledTableFoot, { suppressHydrationWarning: true, fixedHeaderColumn: fixedHeaderColumn }, children));
};
